import React, { memo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { createSelector } from 'reselect'

import { Grid, makeStyles } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

import SearchField from '~/containers/SearchField'
import useViewportSize from '~/components/useViewportSize'

import ProductHeader from './ProductHeader'
import HeaderSearchWrapper from './HeaderSearchWrapper'
import SearchProductByStore from './SearchProductByStore'
import PositionButton from './PositionButton'

import { TYPES } from '~/actions'

const selector = createSelector(
  (state) => state.app.view,
  (state) => state.app.currentProduct,
  (state) => state.config,
  (...args) => args
)

const useStyles = makeStyles((theme) => ({
  boxImage: {
    width: '100%',
    height: 38,
    display: 'flex',
    alignItems: 'center'
  },
  customerBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 49,
    width: '100%',
    backgroundColor: '#FFF',
    margin: 0,
    padding: '0 10px 0 10px'
  },
  resselButton: {
    width: '100%',
    color: theme.palette.primary.main
  },
  inputSearch: {
    borderBottom: '1px solid #70707010',
    padding: 8
  }
}))

function Header({ config, position }) {
  const classes = useStyles()
  const viewport = useViewportSize()

  const [view, product] = useSelector(selector, shallowEqual)

  const isMobile = viewport.width < 930

  const { showContextViewStore } = config

  return (
    <>
      <PositionButton classes={classes} position={position} />

      {view === TYPES.VIEW_STORES || view === TYPES.VIEW_STORE_DETAILS ? (
        product ? (
          <ProductHeader product={product} view={view} position={position} config={config} />
        ) : (
          <Grid style={{ padding: 15 }}>
            <Skeleton variant="rect" width="100%" height={50} />
          </Grid>
        )
      ) : (
        <>
          {!config.showContextViewEstablishment && (
            <Grid {...(isMobile && { className: classes.inputSearch })}>
              <HeaderSearchWrapper position={position} config={config}>
                {showContextViewStore ? (
                  <SearchProductByStore position={position} config={config} />
                ) : (
                  <SearchField position={position} />
                )}
              </HeaderSearchWrapper>
            </Grid>
          )}
        </>
      )}
    </>
  )
}

export default memo(Header)
